<template>
  <div class="process-modal-container">
    <!-- 申请用印弹层 -->
    <van-popup :show="processShow" round position="bottom"
      :style="{ height: '75%', 'border-radius': '8px 8px 0px 0px' }" :close-on-click-overlay="true" @close="closePop">
      <div class="popup_head">
        <div class="head">
          <span class="title">请选择业务流程</span>
          <span class="close" @click="closePop">关闭</span>
        </div>

        <div class="department-box">
          <div class="left-box">
            <template v-if="checkDept.departmentId != checkDept.ownershipId">
              <div class="dep-box text-ellipsis">
                {{ checkDept.departmentName }}
              </div>
              -
            </template>
            <div class="company-name">
              <div class="company-name-box">
                <div class="name">
                  {{ checkDept.ownershipName }}
                </div>
              </div>
            </div>
            <!-- <div class="company-box text-ellipsis"></div> -->
          </div>
          <div class="check-btn" v-if="deptList?.length > 1" @click="checkDep">
            切换部门
            <img src="@/assets/images/apply/check-icon.png" alt="" />
          </div>
        </div>

        <div class="search-box">
          <van-search v-model="searchValue" :placeholder="placeholderText" left-icon="" class="search-input"
            :clearable="false" @search="getProcessList" @update:model-value="getProcessList">
            <template #right-icon>
              <img src="@/assets/images/selectSeal/search.png" @click="getProcessList" alt="" class="search-icon" />
            </template>
          </van-search>
        </div>
      </div>
      <div class="popup_contant">
        <div v-for="(item, index) in businessList" :key="index">
          <div class="business-item"
            @click="$emit('toApply', item.processId, checkDept.departmentId, item.processDefinitionId)" :style="index === businessList.length - 1 ? { marginBottom: '0' } : {}
              ">
            <div class="business-left">
              <div :class="['business-title', showRemark ? 'single-row' : 'double-row']">{{ item.processName }}</div>
              <div v-if="showRemark" class="business-content" :style="{
                color:
                  item.remark && item.remark.length > 0
                    ? '#323233'
                    : '#969799',
              }">
                {{ item.remark || "暂无说明" }}
              </div>
            </div>
            <span class="iconfont icon-qianjin"></span>
          </div>
          <p v-if="index === businessList.length - 1" class="bottom-p">
            已经到底了~
          </p>
        </div>
        <!-- 缺省图 -->
        <div v-if="!businessList.length" class="default">
          <img src="@/assets/images/apply/no-flow-list.png" alt="" class="no-search-res-img" />
          <span class="no-search-span">暂无业务流程</span>
        </div>
      </div>
    </van-popup>

    <van-popup v-model:show="depPopupShow" round position="bottom"
      :style="{ height: '60%', 'border-radius': '8px 8px 0px 0px' }" :close-on-click-overlay="true" @close="closeDep">
      <div class="popup_head">
        <div class="head dep_head">
          <span class="title">切换所在部门</span>
          <span class="close" @click="closeDep">关闭</span>
        </div>
      </div>
      <div class="popup_contant" style="padding-top: 62px">
        <div v-for="(item, index) in deptList" :key="index">
          <div class="business-item" @click="toCheckList(item)"
            :style="index === deptList.length - 1 ? { marginBottom: '0' } : {}">
            <div class="business-left">
              <div class="business-title">{{ item.departmentName }}</div>
              <div class="business-content" :style="{
                color:
                  item.ownershipName && item.ownershipName.length > 0
                    ? '#323233'
                    : '#969799',
              }">
                {{ item.ownershipName || "暂无说明" }}
              </div>
            </div>
            <img class="check-img" :src="item.departmentId == checkDept.departmentId ? check : nocheck
              " alt="" />
          </div>
          <p v-if="index === deptList.length - 1" class="bottom-p">
            已经到底了~
          </p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { watch, reactive, toRefs } from "vue";
import { getDeptList, getProcess } from "@/api/seal/seal";
import check from "@/assets/images/device/check.png";
import nocheck from "@/assets/images/device/nocheck.png";
import { getGoodsProcess } from '@/api/goodApplyApi/goodApply'
import { log } from "mqtt/dist/mqtt";
export default {
  props: {
    processShow: {
      // 业务流程弹窗
      type: Boolean,
      value: false,
    },
    deptList: {
      // 部门列表
      type: Array,
      value: [],
    },
    goodsFlow: {
      //物品流程
      type: Boolean,
      value: false,
    },
    placeholderText: {
      type: String,
      default: '请输入流程名称'
    }
  },
  emits: ["changeShow", "closePop", "toApply"],
  setup(props, { emit }) {
    const state = reactive({
      businessList: [], // 业务流程
      depPopupShow: false,
      searchValue: "",
      searchValueStorage: "", // 关闭弹窗时候缓存搜索内容
      depLoading: false,
      checkDept: {}, // 默认选中的部门
    });
    const showRemark = !props.goodsFlow;

    // 关闭业务流程弹窗
    const closePop = () => {
      state.searchValue = "";
      emit("closePop");
      // state.checkDept = {};
    };

    // 切换部门
    const checkDep = () => {
      event.preventDefault();
      state.searchValueStorage = state.searchValue;
      state.depPopupShow = true;
      emit("changeShow", false);
    };

    // 关闭部门弹窗
    const closeDep = () => {
      // console.log('存储的', state.searchValueStorage);
      if (state.searchValueStorage && state.searchValueStorage != "") {
        state.searchValue = state.searchValueStorage;
      }
      state.searchValueStorage = "";
      emit("changeShow", true);
      state.depPopupShow = false;
    };

    // 选择部门
    const toCheckList = (it) => {
      if (state.depLoading) return;
      state.depLoading = true;
      // console.log('存储的', state.searchValueStorage);
      state.searchValue = state.searchValueStorage;
      state.searchValueStorage = "";
      state.checkDept = it;
      // getProcessList()
      setTimeout(() => {
        state.depPopupShow = false;
        emit("changeShow", true);
        state.depLoading = false;
      }, 200);
    };

    const getProcessList = async () => {
      var flowApiFunc = props.goodsFlow ? getGoodsProcess : getProcess;
      const res = await flowApiFunc({
        processName: state.searchValue,
        deptId: state.checkDept.departmentId,
      });
      if (res.code === 0) {
        state.businessList = res.data;
        // state.checkDept = props.deptList[0]
      }
    };

    watch(
      () => props.deptList,
      (newValue) => {
        if (newValue) {
          state.checkDept = props.deptList[0];
          console.log('当前部门1', JSON.stringify(state.checkDept));

        }
      }
    );

    watch(
      () => props.processShow,
      async () => {
        setTimeout(() => {
          if (props.processShow) {
          state.businessList = []
          console.log('当前部门2', state.checkDept.departmentId);
          if (!state.checkDept.departmentId) {
            state.checkDept = props.deptList[0];
          }
          getProcessList();
          console.log('当前部门3', JSON.stringify(state.checkDept));

        }
        }, 0);
      }
    );



    return {
      ...toRefs(state),
      checkDep,
      closeDep,
      toCheckList,
      nocheck,
      check,
      closePop,
      getProcessList,
      showRemark,
    };
  },
};
</script>

<style lang="less" scoped>
.popup_head {
  width: 100%;
  padding: 16px;
  position: fixed;
  background: white;
  border-radius: 8px 8px 0 0;

  .head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    .title {
      color: #000;
      font-size: 18px;
      font-weight: 500;
    }

    .close {
      font-size: 15px;
      color: #646566;
    }
  }

  .dep_head {
    margin-bottom: 0px;
  }

  .department-box {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 16px;

    .left-box {
      display: flex;
      font-weight: 400;
      color: #323233;
      font-size: 14px;
      width: 261px;

      .dep-box {
        max-width: 140px;
      }

      .company-name {
        flex: 1;
        overflow: hidden;
      }

      .company-name-box {
        display: flex;
      }

      .name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .company-box {
        // max-width: 112px;
      }
    }

    .check-btn {
      display: flex;
      align-items: center;
      color: #2a68e7;

      img {
        width: 14px;
        height: 14px;
      }
    }
  }

  .search-box {
    .search-input {
      padding: 0;
      border-radius: 4px;
      background: transparent;
      height: 40px;
      align-items: center;

      .search-icon {
        width: 16px;
        height: 16px;
        position: absolute;
        right: 0px;
        top: 50%;
        transform: translateY(-50%);
      }

      :deep(.van-search__content) {
        height: 40px;
        padding-left: 12px;
      }

      :deep(.van-cell.van-cell--borderless.van-field.van-search__field.search-input) {
        height: 40px;
      }
    }
  }
}

.popup_contant {
  padding: 0 16px;
  padding-top: 146px;

  .business-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    height: 67px;
    background: #f5f6f7;
    margin-bottom: 12px;
    border-radius: 4px;

    .business-left {
      width: 283px;
      flex-shrink: 0;

      .business-title {
        font-size: 16px;
        font-weight: 500;
        color: #131314;
        line-height: 22px;
      }

      .business-content {
        font-size: 12px;
        font-weight: 400;
        color: #323233;
        line-height: 17px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-top: 4px;

      }
    }

    .check-img {
      width: 18px;
      height: 18px;
    }

    span {
      font-size: 20px;
    }
  }

  .bottom-p {
    font-size: 12px;
    font-weight: 400;
    color: #969799;
    line-height: 17px;
    margin-top: 8px;
    margin-bottom: 12px;
    text-align: center;
  }

  .popup_item {
    color: #000;
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;

    img {
      width: 58px;
      height: 58px;
    }

    span {
      display: block;
      font-size: 14px;
      width: 100%;
      margin-top: 6px;
    }
  }
}

.default {
  width: 100%;
  position: relative;
  top: 100px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;

  .no-search-res-img {
    width: 314px;
    height: 168px;
    margin-bottom: 2px;
  }

  .no-search-span {
    font-size: 14px;
    font-weight: 400;
    color: #969799;
  }
}

.text-ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>